import React from 'react';

import { retry, put } from 'redux-saga/effects';

import { toast } from 'react-toastify';

import { Creators as ModalidadeActions } from '../ducks/modalidade';

import { contratantesAPI } from '../../services/api';

import { ErrorToast } from '../../components/molecules/Toast';

export function* consultaModalidades(action) {
  const { codigoContratante, getInativos } = action.payload.params;
  if (codigoContratante)
    try {
      const response = yield retry(
        2,
        2000,
        contratantesAPI.get,
        `${codigoContratante}/modalidades`,
        { params: { inativos: getInativos } }
      );

      const success = response.status === 200 || false;

      const modalidades = response.data;

      const dataModalidades = {
        ...action.payload,
        response: modalidades,
        success,
      };

      yield put(
        ModalidadeActions.getModalidadesSuccess(
          dataModalidades.response,
          dataModalidades.success
        )
      );
    } catch (error) {
      yield put(ModalidadeActions.getModalidadesError(error));
      toast.error(
        <ErrorToast size="30">
          Não foi possível realizar a conexão para consulta de modalidades.
        </ErrorToast>
      );
    }
}
